import resolveContactLink from "~/helpers/resolveContactLink";
import resolveLink from "~/helpers/resolveLink";

const firstRunLinks = {
	fulfillTourUrl: resolveLink(import.meta.env.VITE_FULFILL_TOUR_URL),
	migrationHubUrl: resolveLink(import.meta.env.VITE_MIGRATION_HUB_URL),
	trialContactUrl: resolveContactLink(import.meta.env.VITE_TRIAL_CONTACT_URL)
};

export default firstRunLinks;
